import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent,
  HttpHeaders
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { SpinnerService } from './spinner.service';

/**
 * The service respoSnsible of intercepting requests
 */
@Injectable()
export class SpinnerInterceptorService implements HttpInterceptor {
  /**
   * The constructor
   * @param {LoaderService} loaderService
   * @param {Router} router
   * @param {ExceptionService} exceptionService
   * @return {void}
   */
  private count = 0;


  constructor(
    private spinnerService: SpinnerService,
    public router: Router,
  ) { }
  /**
   * @param {HttpRequest<any>} req - The http request
   * @param {HttpHandler} next - The http handler
   * @return {Observable<HttpEvent<any>>}
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const hideSpinnerKey = req.headers.get(CustomSpinnerRequestHeader.hideSpinnerKey);

    if (hideSpinnerKey === "true") {
      return next.handle(req);
    } else {
      // start our loader here
      if (this.count === 0) {
        this.spinnerService.setHttpProgressStatus(true);
      }
      this.count++;
    }

    return next.handle(req).pipe(
      finalize(() => {
        this.count--;
        if (this.count === 0) {
          this.spinnerService.setHttpProgressStatus(false);
        }
      }),
      // stop loader Service
      catchError((err: HttpErrorResponse) => {
        return throwError(err);
      })
    );
  }

}

export class CustomSpinnerRequestHeader extends HttpHeaders {
  static hideSpinnerKey: string = 'hideSpinnerKey';
  constructor(hide: boolean, headers?: { [name: string]: string }) {
    if (hide == null && hide == undefined) hide = false;
    super({ hideSpinnerKey: hide.toString(), ...headers });
  }
}